var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { CycleDot_ } from './CycleDot_';
import { CycleDotReward_ } from './CycleDotReward_';
let CycleDots_ = class CycleDots_ extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (!app.tray.trayBar.cycleInBar)
            return null;
        if (app.tray.trayBar.cycleInBar.cycleAnswers.allAnswersInCycle.length === 0)
            return null;
        return (React.createElement("div", { style: { flex: '1 1 auto', display: 'flex', alignItems: 'center', paddingLeft: 10, paddingRight: 10 } },
            app.tray.trayBar.cycleInBar.cycleAnswers.allAnswersInCycle.map(answer => (React.createElement(CycleDot_, { answer: answer, key: answer.id }))),
            app.cycle.cycleReward.doesCycleHaveAReward && React.createElement(CycleDotReward_, { app: app })));
    }
};
CycleDots_ = __decorate([
    observer
], CycleDots_);
export { CycleDots_ };
